// web-login talks to auth directly, not through a BFF — every route below carries
// credentials, OTPs or tokens in its body. Excluded from network capture.
export const PROTECTED_URLS = [
  /\/mfa\//,
  /\/oauth\//,
  /\/oidc-ssk\//,
  /\/saml\//,
  /\/saml-ssk\//,
  /\/dbsc\//,
  /\/agent\//,
  /\/escalation\//,
  /\/internal\//,
  /\/jwt-exchange/,
  /\/load_auth/,
];
